import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@icon/flag.svg'
import _imports_1 from '@icon/check.svg'
import _imports_2 from '@icon/doubleCheck.svg'


const _hoisted_1 = ["role", "tabindex"]
const _hoisted_2 = { class: "to-do__item__content" }
const _hoisted_3 = { class: "to-do__item__title-row" }
const _hoisted_4 = {
  key: 2,
  class: "custom-label is-preview"
}
const _hoisted_5 = { class: "to-do__item__name-wrapper" }
const _hoisted_6 = { class: "to-do__item__properties" }
const _hoisted_7 = { class: "to-do__item__owner-groups" }
const _hoisted_8 = {
  key: 0,
  class: "to-do__item__completion-progress"
}
const _hoisted_9 = { class: "to-do__item__completion-count" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "of", -1)
const _hoisted_11 = { class: "to-do__item__completion-count" }
const _hoisted_12 = {
  key: 2,
  class: "to-do__item__completed-owners"
}
const _hoisted_13 = { class: "to-do__item__owners-header" }
const _hoisted_14 = { class: "to-do__item__info-user" }
const _hoisted_15 = {
  key: 0,
  class: "to-do__item__created-by"
}
const _hoisted_16 = {
  key: 0,
  class: "custom-label is-preview"
}
const _hoisted_17 = {
  key: 2,
  class: "to-do__item__files"
}
const _hoisted_18 = { class: "to-do__item__file-info" }
const _hoisted_19 = { class: "to-do__item__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_LabelPreviewText = _resolveComponent("LabelPreviewText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AvatarGroupToDo = _resolveComponent("AvatarGroupToDo")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_FilePic = _resolveComponent("FilePic")!
  const _directive_ticket = _resolveDirective("ticket")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["to-do__item__wrapper", { 'to-do__item__wrapper_details': _ctx.showDescriptionProp }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["to-do__item", [
        { 'is-show-users': _ctx.isSent, 'is-completed': _ctx.doneToDo },
        { 'to-do__item_details': _ctx.showDescriptionProp },
        `is-${_ctx.item.status.toLowerCase()}`
      ]]),
      role: _ctx.showDescriptionProp ? undefined : 'button',
      tabindex: _ctx.showDescriptionProp ? undefined : 0,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onItemClick && _ctx.onItemClick(...args)))
    }, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["to-do__item__checkbox", [{ 'pointer-none': _ctx.disableCheckbox }]]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCheckboxClick && _ctx.onCheckboxClick(...args)), ["stop"]))
      }, [
        _createVNode(_component_icon, {
          data: _ctx.getToDoIcon.icon,
          color: _ctx.getToDoIcon.color,
          fill: true,
          original: "",
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        }, null, 8, ["data", "color"])
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.item.urgent)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 0,
                data: _imports_0,
                class: "to-do__item__flag",
                fill: true,
                width: "var(--icon-16)",
                height: "var(--icon-16)",
                color: "var(--serviceAlert-02)"
              }))
            : _createCommentVNode("", true),
          (_ctx.item.sequenceNumber)
            ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                key: 1,
                size: "large",
                weight: "500",
                color: "monochrome-05",
                darkColor: "monochrome-04",
                class: "to-do__item__sequence-number"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" TD-" + _toDisplayString(_ctx.item.sequenceNumber), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.item.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_LabelPreviewText, {
                  label: _ctx.item.label
                }, null, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, [
            (_ctx.ticketParams?.relatedUrl)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.getRouteHref(_ctx.ticketParams.relatedUrl),
                  class: _normalizeClass(["link to-do__item__name", [{ 'check-done': _ctx.checkedToDo }]]),
                  onClick: _withModifiers(_ctx.onRelatedUrlClick, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.displayName), 1)
                  ]),
                  _: 1
                }, 8, ["to", "class", "onClick"]))
              : _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                  key: 1,
                  class: _normalizeClass(["to-do__item__name", [{ 'check-done': _ctx.checkedToDo }]]),
                  size: "large",
                  weight: "400",
                  color: "monochrome-06"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.displayName), 1)
                  ]),
                  _: 1
                }, 8, ["class"])), [
                  [_directive_ticket, _ctx.ticketParams]
                ]),
            (_ctx.reviewRequestTitle && _ctx.createdBy.username)
              ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                  key: 2,
                  size: "large",
                  weight: "400",
                  color: "monochrome-07",
                  darkColor: "monochrome-06",
                  class: _normalizeClass(["to-do__item__review-requester", { 'check-done': _ctx.checkedToDo }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" by " + _toDisplayString(_ctx.createdBy.username), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_tooltip, {
              content: _ctx.displayName,
              theme: 'info-tooltip',
              distance: 10,
              skidding: 16,
              placement: 'bottom',
              popperClass: 'to-do__tooltip-info'
            }]
          ]),
          (_ctx.showDescriptionProp && _ctx.canEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                id: "to-do-edit-button",
                type: "button",
                class: "link is-large to-do__item__edit-button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEdit && _ctx.onEdit(...args)), ["stop"]))
              }, " Edit "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.deadlineStatus)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["to-do__item__due", `is-${_ctx.deadlineStatus}`])
              }, _toDisplayString(_ctx.dueLabel), 3))
            : _createCommentVNode("", true),
          (_ctx.item.owners.length)
            ? (_openBlock(), _createBlock(_component_VDropdown, {
                key: 1,
                class: "to-do__item__owners",
                disabled: !_ctx.isSentInProgress && _ctx.item.owners.length <= 1,
                triggers: ['hover'],
                popperHideTriggers: ['hover'],
                popperShowTriggers: ['hover'],
                showGroup: `to-do-${_ctx.index}`,
                placement: "bottom-end",
                popperClass: 
              _ctx.isSentInProgress ? 'to-do__item__completion-tooltip' : 'to-do__item__info__wrapper'
            ,
                theme: "info-dropdown",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, {
                popper: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_BaseSubHeading, {
                      size: "large",
                      weight: "500",
                      className: `to-do__item__owners-status is-${_ctx.ownersStatus.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`toDoOwnerStatus.${_ctx.ownersStatus.id}`)), 1)
                      ]),
                      _: 1
                    }, 8, ["className"]),
                    _createVNode(_component_BaseSubHeading, {
                      size: "medium",
                      weight: "500",
                      color: "monochrome-05",
                      darkColor: "monochrome-04"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`toDoCompletionRule.${_ctx.item.completionRule}`)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.owners, (owner, ownerIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: owner.id || ownerIndex,
                      class: _normalizeClass(["to-do__item__info", { 'to-do__item__completion-tooltip-user': _ctx.isSentInProgress }])
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Avatar, {
                          src: owner.pictureUrl,
                          gap: owner.getInitials()
                        }, null, 8, ["src", "gap"]),
                        _createVNode(_component_BaseSubHeading, {
                          size: "large",
                          weight: "400",
                          color: "monochrome-06"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(owner.username), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      (_ctx.item.ownersCompletionStatuses[owner.id])
                        ? (_openBlock(), _createBlock(_component_icon, {
                            key: 0,
                            data: _imports_2,
                            class: "to-do__item__completion-check",
                            fill: true,
                            width: "var(--icon-24)",
                            height: "var(--icon-24)"
                          }))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.isSentInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.completedOwnersCount), 1),
                          _hoisted_10,
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.item.owners.length), 1),
                          _createVNode(_component_icon, {
                            data: _imports_1,
                            class: "to-do__item__completion-check",
                            fill: true,
                            width: "var(--icon-24)",
                            height: "var(--icon-24)"
                          })
                        ]))
                      : (_ctx.isSentCompletedByEveryone)
                        ? (_openBlock(), _createBlock(_component_AvatarGroupToDo, {
                            key: 1,
                            avatars: _ctx.item.owners,
                            numberOfVisibleUsers: 5,
                            type: "avatarGroup",
                            size: "md"
                          }, null, 8, ["avatars"]))
                        : (_ctx.completedOwners.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_AvatarGroupToDo, {
                                avatars: _ctx.completedOwners,
                                numberOfVisibleUsers: 5,
                                type: "avatarGroup",
                                size: "md"
                              }, null, 8, ["avatars"]),
                              _createVNode(_component_icon, {
                                data: _imports_1,
                                class: "to-do__item__completed-owners-check to-do__item__completion-check",
                                fill: true,
                                width: "var(--icon-16)",
                                height: "var(--icon-16)"
                              })
                            ]))
                          : _createCommentVNode("", true),
                    (!_ctx.isSentInProgress && !_ctx.isSentCompletedByEveryone && _ctx.remainingOwners.length)
                      ? (_openBlock(), _createBlock(_component_AvatarGroupToDo, {
                          key: 3,
                          avatars: _ctx.remainingOwners,
                          numberOfVisibleUsers: 5,
                          type: "avatarGroup",
                          size: "md"
                        }, null, 8, ["avatars"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "showGroup", "popperClass"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 10, _hoisted_1),
    (_ctx.showDescriptionProp)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["to-do__item__body to-do__item__body_details", { 'is-review': _ctx.reviewRequestTitle }])
        }, [
          (_ctx.createdBy.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_Avatar, {
                  src: _ctx.createdBy.pictureUrl ?? null,
                  gap: _ctx.createdBy.getInitials(),
                  bordered: ""
                }, null, 8, ["src", "gap"]),
                _createVNode(_component_BaseSubHeading, {
                  size: "large",
                  weight: "500",
                  color: "monochrome-06",
                  class: "to-do__item__created-by__name"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.createdBy.username), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_BaseSubHeading, {
                  size: "medium",
                  weight: "400",
                  color: "monochrome-06"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" assigned you a new ToDo Item: ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.item.item && _ctx.ticketParams.relatedUrl)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: _ctx.getRouteHref(_ctx.ticketParams.relatedUrl),
                class: "to-do__item__review-resource",
                onClick: _withModifiers(_ctx.onRelatedUrlClick, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseSubHeading, {
                    size: "large",
                    weight: "500",
                    color: "monochrome-05",
                    darkColor: "monochrome-04",
                    class: "to-do__item__review-resource-number"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(_ctx.item.item.sequenceNumber), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.item.item.label)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_LabelPreviewText, {
                          label: _ctx.item.item.label
                        }, null, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BaseSubHeading, {
                    size: "large",
                    weight: "400",
                    color: "monochrome-07",
                    darkColor: "monochrome-06",
                    class: "to-do__item__review-resource-title"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.item.item.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Editor, {
            id: "body-description",
            type: "read",
            class: _normalizeClass(["to-do__item__description", { 'to-do__item__description_review': _ctx.reviewRequestTitle }]),
            targetConfig: _ctx.typeConfig,
            value: _ctx.item.structuredDescription.html,
            extensions: _ctx.extensions,
            isBodyColor: true
          }, null, 8, ["class", "targetConfig", "value", "extensions"]),
          (_ctx.reviewRequestTitle && _ctx.attachments.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.id,
                    class: "to-do__item__file"
                  }, [
                    _createVNode(_component_FilePic),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_BaseSubHeading, {
                        weight: "400",
                        size: "medium",
                        color: "monochrome-07",
                        className: "to-do__item__file-name"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(file.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_BaseSubHeading, {
                        weight: "500",
                        size: "extra-small",
                        color: "monochrome-05",
                        darkColor: "monochrome-04"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getFileSize(file.size)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_BaseSubHeading, {
              size: "extra-small",
              weight: "400",
              color: "monochrome-05",
              darkColor: "monochrome-04",
              className: "to-do__item__created-time"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.createdTimeAgo), 1)
              ]),
              _: 1
            })
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}